module.exports = __webpack_public_path__ + "img/car.8afdc66a.svg";